import { User } from "@/models/user";
import { ACTIONS } from "./actions";
import { AppContext } from "@/models/context";

type MainAction = 
    |{type:ACTIONS.SET_USER,payload:{user:User}}
    |{type:ACTIONS.SET_LOADING,payload:{isLoading:boolean}}
    |{type:ACTIONS.SET_BUTTON,payload:{currentButton:number}}
    |{type:ACTIONS.SET_RELOAD,payload:{showReload:boolean}}


export const mainReducer = (state:AppContext,action:MainAction) =>{
    switch (action.type) {
        case 'setUser':
            return  {
                ...state,
                user: action.payload.user
            }
        case 'setLoading':
            return {
                ...state,
                isLoading: action.payload.isLoading
            }
        case 'setReload':
            return {
                ...state,
                sowReload: action.payload.showReload
            }
        case 'setButton':
            return {
                ...state,
                currentButton: action.payload.currentButton
            }
        default:
            return state;
    }
}